<template>
  <div>
    <!-- 头部 -->
    <x-header />

    <header class="masthead masthead-main">
      <div class="container px-3">
        <div class="row gx-5 align-items-center">
          <div class="col-lg-6">
            <!-- Mashead text and app badges-->
            <div class="mb-5 mb-lg-0 text-center text-lg-start">
              <div class="masthead-main-linear"></div>
              <h1 class="display-1 lh-1 mb-3" style="margin-left: 10px;">Welcome to PokerMan!</h1>  <!-- style="color: #bca967;" -->
              <p class="lead fw-normal mb-5" style="color: #d7d7d7;margin-left: 10px;">PokerMan is a secure online poker app that has been created with the aim of benefiting the poker community by providing a platform where players can easily play home games with friends online. The application is designed to be easy for anyone to use.</p>
            </div>
          </div>

          <div class="col-lg-6">
            <!-- Masthead device mockup feature-->
            <div class="masthead-device-mockup">
              <div class="device-wrapper">
                <div class="device" data-device="iPhoneX" data-orientation="portrait" data-color="black">
                  <div class="screen bg-black">
                    <video preload="auto" muted="muted" autoplay="autoplay" loop="loop" playsInline data-wf-ignore="true" data-object-fit="cover" poster="/static/img/screen_poster.jpg?t=1680000742" style="max-width: 100%; height: 102%">
                      <source src="/static/img/screen.mp4?t=1680000743" type="video/mp4" data-wf-ignore="true" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="container px-3" style="margin-top: 4rem;">
        <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center">
          <a class="me-lg-3 mb-4 mb-lg-0" target="_blank" href="https://play.google.com/store/apps/details?id=com.game.android.pokerman">
            <img class="app-badge" :src="googlePlayBadgeUrl" alt="...">
          </a>
          <a class="me-lg-3 mb-4 mb-lg-0" target="_blank" href="https://apps.apple.com/us/app/pokerman-poker-with-friends/id1643282348">
            <img class="app-badge" :src="appstoreBadgeUrl" alt="...">
          </a>
          <a class="me-lg-3 mb-4 mb-lg-0" target="_blank" href="https://storage.googleapis.com/static-pm/version/website/PokerMan1.3.10.apk?t=1789627222">
            <img class="app-badge" :src="androidBadgeUrl" alt="...">
          </a>
          <!-- <a href="#!">
            <img class="app-badge" :src="windowsBadgeUrl" alt="...">
          </a> -->
        </div>
      </div>
    </header>

    <!-- section 1 -->
    <section class="section-main">
      <div class="container px-3 section-container">
        <div class="row gx-5 align-items-center">
          <div class="col-lg-6 order-lg-1">
            <div class="container-fluid px-5">
              <div class="masthead-right-linear"></div>
              <h2 class="display-1 lh-1 mb-4 masthead-right-title">
                FREE UNLIMITED CLUB CHIPS
              </h2>
              <!-- <p class="lead fw-normal text-white mb-5"></p> -->
            </div>
          </div>
          <div class="col-lg-6 order-lg-0">
            <div class="section-background-1"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- section 2 -->
    <section class="section-main">
      <div class="container px-3 section-container">
        <div class="row gx-5 align-items-center">
          <div class="col-lg-6">
            <div class="container-fluid px-5">
              <div class="masthead-left-linear"></div>
              <h2 class="display-1 lh-1 mb-4 masthead-left-title">
                SUPPORTS MULTIPLE POKER VARIANTS
              </h2>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="section-background-2"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- section 3 -->
    <section class="section-main">
      <div class="container px-3 section-container">
        <div class="row gx-5 align-items-center">
          <div class="col-lg-6 order-lg-1">
            <div class="container-fluid px-5">
              <div class="masthead-right-linear"></div>
              <h2 class="display-1 lh-1 mb-4 masthead-right-title">
                FREE CLUB LEVEL FOR 9,999 MEMBERS
              </h2>
            </div>
          </div>

          <div class="col-lg-6 order-lg-0">
            <div class="section-background-3"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <x-footer />
  </div>
</template>

<script>
import footer from '@/views/components/footer'
import header from '@/views/components/header'
import googlePlayBadge from '@/assets/images/google-play-badge.png'
import appstoreBadge from '@/assets/images/app-store-badge.png'
import androidBadge from '@/assets/images/android-badge.png'
import windowsBadge from '@/assets/images/windows-badge.png'

export default {
  name: 'Home',
  components: {
    'x-header': header,
    'x-footer': footer
  },

  data () {
    return {
      googlePlayBadgeUrl: googlePlayBadge,
      appstoreBadgeUrl: appstoreBadge,
      androidBadgeUrl: androidBadge,
      windowsBadgeUrl: windowsBadge
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- 覆盖样式 -->
<style>
</style>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/index.vue